import api from '@pray/shared/utils/api';

export type CampaignActivity = {
  id: string;
  type: string;
  title: string;
  message: string;
  metadata: Record<string, unknown> | null;
  source: string | null;
  actor: { id: string | null };
  created_at: string;
};

export type CampaignActivitiesPage = {
  items: CampaignActivity[];
  page: number;
  limit: number;
  total: number;
};

export type GetMarketingCampaignActivitiesParams = {
  artistId: string;
  campaignId: string;
  page?: number;
  limit?: number;
  type?: string | null;
};

export const getMarketingCampaignActivities = async ({
  artistId,
  campaignId,
  page = 1,
  // A campaign's log is read as one ordered thread, and the order carries the meaning, so the whole
  // thread is fetched rather than a first page of it. The busiest campaign on record holds 13 entries.
  limit = 100,
  type = null,
}: GetMarketingCampaignActivitiesParams): Promise<{ data: CampaignActivitiesPage }> => {
  const params: Record<string, string> = { page: String(page), limit: String(limit) };
  if (type) {
    params.type = type;
  }

  const url = `/web/studio/artists/${artistId}/marketing-campaigns/${campaignId}/activities`;
  const response = await api.executeGetRequest(url, params);

  return response.data;
};
